import produce from "immer";
import { IStoreState } from "../../initialStoreState";
import { LoadState } from "../../../constants/enums";
import { initialCommAutomobileMarketingHistoryState } from "./commAutoMarketingHistory.types";
import { CommAutomobileMarketingHistoryActions } from ".";
import { CLEAR_COMM_AUTOMOBILE_POLICY_MARKETING_HISTORY, CLEAR_COMM_AUTOMOBILE_POLICY_MARKETING_STATE, CLEAR_COMM_AUTO_POLICY_MARKETING_FORM_STATE, CLEAR_COMM_AUTO_POLICY_MARKETING_LIST_STATE, CLEAR_COMM_AUTO_POLICY_MARKETING_STATE, FETCH_COMMAUTO_POLICY_BINDER_LIST_FAILED, FETCH_COMMAUTO_POLICY_BINDER_LIST_PROGRESS, FETCH_COMMAUTO_POLICY_BINDER_LIST_SUCCESS, FETCH_COMM_AUTOMOBILE_POLICY_MARKETING_HISTORY_FAILED, FETCH_COMM_AUTOMOBILE_POLICY_MARKETING_HISTORY_LIST_FAILED, FETCH_COMM_AUTOMOBILE_POLICY_MARKETING_HISTORY_LIST_PROGRESS, FETCH_COMM_AUTOMOBILE_POLICY_MARKETING_HISTORY_LIST_SUCCESS, FETCH_COMM_AUTOMOBILE_POLICY_MARKETING_HISTORY_PROGRESS, FETCH_COMM_AUTOMOBILE_POLICY_MARKETING_HISTORY_SUCCESS, FETCH_COMM_AUTO_CHECKLIST_SAVED_STATUS_PROGRESS, FETCH_COMM_AUTO_CHECKLIST_SAVED_STATUS_SUCCESS, FETCH_COMM_AUTO_CHECKLIST_SAVED_STATUS_FAILED, SAVE_COMM_AUTO_CHECKLIST_RESPONSE_PROGRESS, SAVE_COMM_AUTO_CHECKLIST_RESPONSE_SUCCESS, SAVE_COMM_AUTO_CHECKLIST_RESPONSE_FAILED } from "./commAutoMarketingHistoryActions";

export const CommAutomobilePolicyMarketingReducer = (
  state: IStoreState["commAuto"]["marketing"] = initialCommAutomobileMarketingHistoryState,
  action: CommAutomobileMarketingHistoryActions
) => {
  switch (action.type) {
    case FETCH_COMM_AUTOMOBILE_POLICY_MARKETING_HISTORY_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.marketingHistoryListLoading = LoadState.InProgress;
        draftState.marketingHistoryList = [];
      });
      return newState;
    }
    case FETCH_COMM_AUTOMOBILE_POLICY_MARKETING_HISTORY_LIST_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.marketingHistoryListLoading = LoadState.Loaded;
        draftState.marketingHistoryList = data;
      });
      return newState;
    }
    case FETCH_COMM_AUTOMOBILE_POLICY_MARKETING_HISTORY_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.marketingHistoryListLoading = LoadState.Failed;
        draftState.marketingHistoryList = [];
      });
      return newState;
    }

    case FETCH_COMM_AUTOMOBILE_POLICY_MARKETING_HISTORY_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.marketingHistoryLoading = LoadState.InProgress;
        draftState.marketingHistory =
        initialCommAutomobileMarketingHistoryState["marketingHistory"];
      });
      return newState;
    }
    case FETCH_COMM_AUTOMOBILE_POLICY_MARKETING_HISTORY_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.marketingHistoryLoading = LoadState.Loaded;
        draftState.marketingHistory = data;
      });
      return newState;
    }
    case FETCH_COMM_AUTOMOBILE_POLICY_MARKETING_HISTORY_FAILED: {
      const {errorMessage} = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.marketingHistoryLoading = LoadState.Failed;
        draftState.error = errorMessage;
      });
      return newState;
    
    }

    case CLEAR_COMM_AUTOMOBILE_POLICY_MARKETING_HISTORY: {
      const newState = produce(state, (draftState) => {
        draftState.marketingHistory = initialCommAutomobileMarketingHistoryState['marketingHistory'];
        draftState.marketingHistoryLoading = LoadState.NotLoaded;
        draftState.error = null;
      });
      return newState;
    }
    case FETCH_COMM_AUTO_CHECKLIST_SAVED_STATUS_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.checklist.savedStatusLoading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_COMM_AUTO_CHECKLIST_SAVED_STATUS_SUCCESS: {
      const { saved, response } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.checklist.savedStatusLoading = LoadState.Loaded;
        draftState.checklist.savedStatus = saved;
        draftState.checklist.response = response;
      });
      return newState;
    }
    case FETCH_COMM_AUTO_CHECKLIST_SAVED_STATUS_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.checklist.savedStatusLoading = LoadState.Failed;
        draftState.checklist.savedStatus = false;
      });
      return newState;
    }
    case SAVE_COMM_AUTO_CHECKLIST_RESPONSE_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.checklist.saveLoading = LoadState.InProgress;
      });
      return newState;
    }
    case SAVE_COMM_AUTO_CHECKLIST_RESPONSE_SUCCESS: {
      const { response } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.checklist.saveLoading = LoadState.Loaded;
        draftState.checklist.savedStatus = true;
        draftState.checklist.response = response;
      });
      return newState;
    }
    case SAVE_COMM_AUTO_CHECKLIST_RESPONSE_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.checklist.saveLoading = LoadState.Failed;
      });
      return newState;
    }

    case CLEAR_COMM_AUTOMOBILE_POLICY_MARKETING_STATE: {
      return initialCommAutomobileMarketingHistoryState;
    }

    case FETCH_COMMAUTO_POLICY_BINDER_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.binderHistory.loading = LoadState.InProgress;
        draftState.binderHistory.list = [];
      });
      return newState;
    }
    case FETCH_COMMAUTO_POLICY_BINDER_LIST_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.binderHistory.loading = LoadState.Loaded;
        draftState.binderHistory.list = data;
      });
      return newState;
    }
    case FETCH_COMMAUTO_POLICY_BINDER_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.binderHistory.loading = LoadState.Failed;
        draftState.binderHistory.list = [];
      });
      return newState;
    }

    case CLEAR_COMM_AUTO_POLICY_MARKETING_STATE: {
      return initialCommAutomobileMarketingHistoryState;
    }

    case CLEAR_COMM_AUTO_POLICY_MARKETING_LIST_STATE: {
      const initial = initialCommAutomobileMarketingHistoryState;
      const newState = produce(state, (draftState) => {
        draftState.marketingHistoryList = initial.marketingHistoryList;
        draftState.marketingHistoryListLoading =
          initial.marketingHistoryListLoading;
        draftState.binderHistory = initial.binderHistory;
      });
      return newState;
    }

    case CLEAR_COMM_AUTO_POLICY_MARKETING_FORM_STATE: {
      const initial = initialCommAutomobileMarketingHistoryState;
      const newState = produce(state, (draftState) => {
        draftState.marketingHistory = initial.marketingHistory;
        draftState.marketingHistoryLoading = initial.marketingHistoryLoading;
        draftState.error = initial.error;
        draftState.checklist = initial.checklist;
      });
      return newState;
    }

    default: {
      return state;
    }
  }
};
